import { type ComponentPropsWithoutRef, useEffect, useState } from 'react';
import { type AvatarData } from '@/api';
import { type PlanType } from '@/types';
import { cn } from '@/utils';
import { AVATAR_BG_COLOR, type AvatarSize, buildBakedAvatarUrl, PLAN_GRADIENT_CLASS, SIZE_MAP } from '../constants/avatar.constants';
import { FallbackAvatar } from './FallbackAvatar';
export const BakedAvatar = ({
  avatarData,
  size = 'xs',
  planType,
  backgroundColor,
  className,
  style,
  ...props
}: ComponentPropsWithoutRef<'div'> & {
  avatarData: AvatarData;
  size?: AvatarSize;
  planType?: PlanType;
  backgroundColor?: string;
}) => {
  const [hasError, setHasError] = useState(false);
  const imageUrl = buildBakedAvatarUrl(avatarData);
  useEffect(() => {
    setHasError(false);
  }, [imageUrl]);
  if (hasError) {
    return <FallbackAvatar size={size} planType={planType} className={className} style={style} {...props} />;
  }
  const gradientClass = PLAN_GRADIENT_CLASS[planType ?? 'FREE'];
  if (!gradientClass) {
    return <div className={cn('relative inline-flex aspect-square shrink-0 overflow-hidden rounded-full border border-[rgba(28,27,31,0.04)]', SIZE_MAP[size], className)} style={{
      backgroundColor: backgroundColor ?? AVATAR_BG_COLOR,
      ...style
    }} {...props}>
        <img src={imageUrl} alt="avatar" className="size-full object-cover" onError={() => !hasError && setHasError(true)} />
      </div>;
  }
  return <div className={cn('relative inline-flex aspect-square shrink-0 rounded-full p-[2px]', gradientClass, SIZE_MAP[size], className)} style={style} {...props} data-sentry-component="BakedAvatar" data-sentry-source-file="BakedAvatar.tsx">
      <div className="flex aspect-square size-full overflow-hidden rounded-full" style={{
      backgroundColor: backgroundColor ?? AVATAR_BG_COLOR
    }}>
        <img src={imageUrl} alt="avatar" className="size-full object-cover" onError={() => !hasError && setHasError(true)} />
      </div>
    </div>;
};